import { Component } from '@angular/core';

@Component({
  selector: 'app-create-default-categories',
  templateUrl: './create-default-categories.component.html',
  styleUrls: ['./create-default-categories.component.scss'],
})
export class CreateDefaultCategoriesComponent {}
